import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { withGlobalLoading } from '../store/loadingStore'

export function useFilterOptions(column: string) {
  const [options, setOptions] = useState<string[]>([])

  useEffect(() => {
    const fetchOptions = async () => {
      const { data, error } = await withGlobalLoading(
        `filter-options-${column}`,
        `Memuat opsi ${column}…`,
        () => supabase.from('Huawei_order').select(column),
      )

      if (error) {
        console.error(error)
        return
      }

      if (data) {
        const unique = Array.from(
          new Set(data.map((item: any) => item[column]).filter(Boolean)),
        )

        setOptions(unique.sort())
      }
    }

    fetchOptions()
  }, [column])

  return options
}
